// extracted by mini-css-extract-plugin
module.exports = {"resultClaimDiv":"NewServiceClaimSearchAndSelectComponent_AX_resultClaimDiv__ukSZm","classInput":"NewServiceClaimSearchAndSelectComponent_AX_classInput__kISCo"};